module.exports = __webpack_public_path__ + "static/rotary-1072ea89288cb070301f4594efcaa24d.jpg";